<app-section-wrapper-container>
	<form
		class="um-section-parent-container"
		[formGroup]="detailsForm"
		(keypress)="onKeyPress($event)">
		<app-duration-picker
			[showTime]="false"
			[startsAt]="detailsForm.get('startsAt')"
			[endsAt]="detailsForm.get('endsAt')"></app-duration-picker>

		<div>
			<app-input-field
				formControlName="externalReference"
				[label]="
					'vehicle-insurances|record|details-section|field-label|external-reference'
				" />
		</div>

		<app-more-sections label="vehicle-insurances|record|details-section|terms">
			<div>
				<app-single-dropdown
					formControlName="premiumPeriod"
					[label]="
						'vehicle-insurances|record|details-section|field-label|premium-period'
					"
					[selectOptions]="premiumPeriods" />
				<app-input-field
					formControlName="excessAmount"
					[label]="
						'vehicle-insurances|record|details-section|field-label|excess-amount'
					"
					[isNumber]="true" />
			</div>

			<div>
				<app-input-field
					formControlName="insuredValue"
					[label]="
						'vehicle-insurances|record|details-section|field-label|insured-value'
					"
					[isNumber]="true" />

				<app-single-dropdown
					formControlName="coverageType"
					[label]="
						'vehicle-insurances|record|details-section|field-label|coverage-type'
					"
					[selectOptions]="coverageTypes" />
			</div>

			<div>
				<app-input-field
					formControlName="totalLossPercentage"
					[label]="
						'vehicle-insurances|record|details-section|field-label|total-loss-percentage'
					"
					[isNumber]="true" />
			</div>
		</app-more-sections>

		<!-- <div>
			<app-stack-label-item
				[label]="
					'vehicle-insurances|record|cost-section|field-label|total-loss-amount'
				"
				[value]="totalLossAmount | currency: 'EUR'" />
		</div> -->
	</form>
</app-section-wrapper-container>
